import { useEffect, useState } from 'react';
import { onScrollToMessageByTask } from 'src/utils';
import { useComparingConversationsParams, useThreadRegistry } from 'src/hooks';
import { Conversation } from 'src/types';

interface UseComparedScrollToTaskParams {
  conversation?: Conversation;
  linkedConversation?: Conversation;
}

export const useComparedScrollToTask = ({
  conversation,
  linkedConversation,
}: UseComparedScrollToTaskParams) => {
  const { firstComparedConvId, secondComparedConvId, isCompareMode } =
    useComparingConversationsParams();

  const { isSubmitHappened } = useThreadRegistry();

  const [comparedActiveThreadAnchor, setComparedActiveThreadAnchor] = useState<
    string | null
  >(null);

  useEffect(() => {
    if (isCompareMode && (!firstComparedConvId || !secondComparedConvId)) {
      setComparedActiveThreadAnchor(null);
    }
  }, [isCompareMode, firstComparedConvId, secondComparedConvId]);

  useEffect(() => {
    if (isSubmitHappened) {
      setComparedActiveThreadAnchor(null);
    }
  }, [isSubmitHappened]);

  useEffect(() => {
    if (
      comparedActiveThreadAnchor &&
      isCompareMode &&
      conversation &&
      linkedConversation
    ) {
      setTimeout(() => {
        const currentTaskIndex =
          conversation?.tasks?.findIndex(
            (task) => task?.task_id === comparedActiveThreadAnchor,
          ) || 0;

        const linkedTaskIdIndex =
          linkedConversation?.tasks?.[currentTaskIndex]?.task_id;

        // (olha): this handler should be called after useScrollToBottomThread
        onScrollToMessageByTask(comparedActiveThreadAnchor);

        if (linkedTaskIdIndex) {
          onScrollToMessageByTask(linkedTaskIdIndex);
        }
      }, 0);
    }
  }, [
    comparedActiveThreadAnchor,
    conversation,
    isCompareMode,
    linkedConversation,
  ]);

  return { comparedActiveThreadAnchor, setComparedActiveThreadAnchor };
};
